export default __webpack_public_path__ + "static/media/a5.153b540a.png";